import { render, staticRenderFns } from "./LoyaltyProgram.vue?vue&type=template&id=0f994cd0&scoped=true"
import script from "./LoyaltyProgram.vue?vue&type=script&lang=js"
export * from "./LoyaltyProgram.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyProgram.vue?vue&type=style&index=0&id=0f994cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f994cd0",
  null
  
)

export default component.exports